import { render, staticRenderFns } from "./baseCurrency.vue?vue&type=template&id=3d757872&"
import script from "./baseCurrency.vue?vue&type=script&lang=js&"
export * from "./baseCurrency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d757872')) {
      api.createRecord('3d757872', component.options)
    } else {
      api.reload('3d757872', component.options)
    }
    module.hot.accept("./baseCurrency.vue?vue&type=template&id=3d757872&", function () {
      api.rerender('3d757872', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/baseCurrency.vue"
export default component.exports